import { useEffect } from 'react';
import { Button, Loader } from '@marekhealth/mhui';
import { IoCloudDoneSharp, IoWarning } from 'react-icons/io5';
import { defaultErrorMessage, iconSize, loadingMessage, successMessage } from './constants';
import { ISubmissionFeedbackProps } from './types';
import * as S from './styles';

export default function SubmissionFeedback({
  isLoading,
  isSuccess,
  errorMessage,
  onTryAgain,
}: ISubmissionFeedbackProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) return (
    <S.Wrapper>
      <Loader size={50} />
      {loadingMessage}
    </S.Wrapper>
  );

  if (isSuccess) return (
    <S.Wrapper $isSuccess={true}>
      <IoCloudDoneSharp size={iconSize} />
      {successMessage}
    </S.Wrapper>
  );

  return (
    <S.Wrapper>
      <IoWarning size={iconSize} />
      {errorMessage || defaultErrorMessage}
      <Button onClick={onTryAgain}>
        Try Again
      </Button>
    </S.Wrapper>
  );
}
